import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import { message, Modal } from "antd";
import { EntLivestockTradeActivity } from "../../../../models/organic/livestockTradeActivity";
import {
  useAddLivestockTradeActivityMutation,
  useDeleteLivestockTradeActivityMutation,
  useEditLivestockTradeActivityMutation
} from "../../../../redux/api/organic/livestockTradeActivityApi";

const useLivestockTradeActivity = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation();
  const { confirm } = modal;
  const [addLivestockTradeActivity] = useAddLivestockTradeActivityMutation();
  const [deleteLivestockTradeActivity] = useDeleteLivestockTradeActivityMutation();
  const [editLivestockTradeActivity] = useEditLivestockTradeActivityMutation();

  async function onAddLivestockTradeActivity(newLivestockTradeActivity: EntLivestockTradeActivity): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addLivestockTradeActivity(newLivestockTradeActivity).then((response: any) => {
		if (response.error) {
		  const isKyrgyz = getCookie('i18next') === 'ky';
		  const lang = isKyrgyz ? 'kg' : 'ru';
		  const res = response.error.data?.res;
		  const errorMessages = Array.isArray(res)
			? res.map((error: any) => error[lang] || error.ru).join('\n')
			: response.error.data?.msg || t('unknownError');
		  throw new Error(errorMessages);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }


  async function onDeleteLivestockTradeActivity(livestockTradeActivity: EntLivestockTradeActivity) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteLivestockTradeActivity(livestockTradeActivity.id as number).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(`${ response.error.data.res.kg } / ${ response.error.data.res.ru }`);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onEditLivestockTradeActivity(editedLivestockTradeActivity: EntLivestockTradeActivity): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editLivestockTradeActivity(editedLivestockTradeActivity).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(`${ response.error.data.res.kg } / ${ response.error.data.res.ru }`);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  };

  return { onAddLivestockTradeActivity, onDeleteLivestockTradeActivity, onEditLivestockTradeActivity };

}

export { useLivestockTradeActivity };

